import React, { Component } from "react";
import PropTypes from "prop-types";
import { StaticQuery, graphql } from "gatsby";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import Helmet from "react-helmet";
import Favicon from "../images/favicon.png";
import Header from "./header";
import Offcanvas from "./offcanvas";
import Footer from "./footer";
library.add(fab);

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offcanvas: false
    };
    this.toggleOffcanvas = this.toggleOffcanvas.bind(this);
  }

  toggleOffcanvas() {
    this.setState(prevState => ({
      offcanvas: !prevState.offcanvas
    }));
    if (!this.state.offcanvas) {
      document.querySelector("html").classList.add("is-clipped");
    } else {
      document.querySelector("html").classList.remove("is-clipped");
    }
  }

  render() {
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <div
            id="site"
            className={
              this.props.location !== "" ? "is-" + this.props.location : ""
            }
          >
            <Helmet>
              <link rel="shortcut icon" href={Favicon} type="image/x-icon" />
            </Helmet>
            <Header
              siteTitle={data.site.siteMetadata.title}
              toggleOffcanvas={this.toggleOffcanvas}
            />
            <main className="content">{this.props.children}</main>
            <Footer />
            <Offcanvas
              toggleOffcanvas={this.toggleOffcanvas}
              isVisible={this.state.offcanvas}
            />
          </div>
        )}
      />
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
